class AccountMenu {
  constructor(elm) {
    this.elm = document.querySelector(elm)
    if (!this.elm) return

    this.menuElm = this.elm.querySelector('.header-top-account-menu')
    this.triggerLink = this.elm.querySelector('.header-top-nav-link')

    this.init()
  }
  showMenu() {
    this.menuElm.style.display = 'block'
  }
  hideMenu() {
    this.menuElm.style.display = 'none'
  }
  init() {
    this.elm.addEventListener('mouseenter', this.showMenu.bind(this))
    this.elm.addEventListener('mouseleave', this.hideMenu.bind(this))
  }
}

document.addEventListener('DOMContentLoaded', function() {
  new AccountMenu('.js-header-top-account')
})
